import { getInitialState } from "./state.js";
const initialState = getInitialState();
const reducer = (state = initialState) => state;
export { reducer, getInitialState };
